import React from 'react';
import { toast } from 'react-toastify';

export function notify(element: React.ReactNode) {
    toast(() => <div className="text-dark">{element}</div>);
}
